<template>
  <v-container grid-list-md data-aos="fade-up">
    <h1 style="font-size:40px;color: #48445E;">My Hobbies</h1>
    <br /><br />
    <v-row >
      <v-col >
        <div class="hobbie web d-flex flex-column justify-center align-center">
          <img src="@/assets/coding.png" width="100" />
          <h2>Web Development</h2>
          <p class="text-center">
            i love to watch css tutorials and make it follows the videos
          </p>
        </div>
      </v-col>
      <v-col>
        <div class="hobbie tech d-flex flex-column justify-center align-center">
          <img src="@/assets/coding1.png" width="100" />
          <h2>Learning Tech Stack</h2>
          <p class="text-center">
            When I'm free I spend time to finding video web application
            development tutorials on youtube. Let's do it!
          </p>
        </div>
      </v-col>
      <v-col>
        <div class="hobbie lang d-flex flex-column justify-center align-center">
          <img src="@/assets/translate.png" width="90" />
          <h2>Learning Foreign Language</h2>
          <p class="text-center">
            Studying english, Korea, Chinese
          </p>
          <Popup />
          <!-- <button slot="activator">Certificate</button> -->
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Popup from "../components/popup";
export default {
  components: {
    Popup,
  },
};
</script>

<style scoped>
.hobbie {
  width: 100%;
  min-height: 250px;
  height: 100%;
  background: white;

  border-radius: 20px;
  padding: 2em;
  cursor: pointer;
}
.hobbie:hover {
  transform: translateY(-15px);
   transition-duration: 0.5s;
}
.hobbie h2 {
  margin-top: 10px;
}
button {
  outline: none;
}
h2 {
  font-size: 20px;
  text-align: center;
}
.web {
  background: #696be6;
  box-shadow: 0px 0px 30px #696be67c;
  color: white;
}
.tech {
  background: #6feccd;
  box-shadow: 0px 0px 30px #60dfbf9a;
}
.lang {
  background: #fe7185;
  box-shadow: 0px 0px 30px #fe718673;
  color: white;
}
.lang button {
  padding: 10px;
  width: 120px;
  border-radius: 10px;
  background: #dc4955;
  text-transform: lowercase;
}
.lang button:active {
  transform: scale(0.9);
}
</style>
